import React from 'react'

//* utils
import { ModuleNames } from '../../../constants/componentNames.constants'
import { LocaleCodes } from '../../../constants/localization.constants'

//* components
import Benefits from '../../global/benefits'
import Bio from '../../global/bio'
import CollapsibleQuadrant from '../../global/collapsibleQuadrant'
import ContentBlock from '../../global/contentBlock'
import ContentColumns from '../../global/contentColumns'
import ContentRows from '../../global/contentRows'
import Divider from '../../global/divider'
import FlexibleHero from '../../global/flexibleHero'
import Grid from '../../global/grid'
import Hero from '../../global/hero'
import KeyStats from '../../global/keyStats'
import MainCTA from '../../global/mainCta'
import MediaText from '../../global/mediaText'
import ParagraphBlock from '../../global/paragraphBlock'
import PlatformDiagram from '../../global/platformDiagram'
import ProductDownload from '../../global/productDownload'
import Quote from '../../global/quote'
import RawHTML from '../../global/rawHTML'
import ResourceLists from '../../global/resourceLists'
import ResourceRow from '../../global/resourceRow'
import ResourceTabs from '../../global/resourceTabs'
import SliderComponent from '../../global/slider'
import SpeakerText from '../../global/speakerText'
import Tables from '../../global/table'
import Tiles from '../../global/tiles'
import VideoSpotlight from '../../global/videoSpotlight'
import Layout from '../../layouts/layout'

const agencyTestPage = ({ pageContext }: any) => {
  const defaultLocale = pageContext?.pageLocale || LocaleCodes.ENGLISH.code
  const { slug, flexSection } = pageContext.data

  const dynamicPageContent = flexSection?.map((module: any, i: number) => {
    switch (module?.__typename) {
      case ModuleNames.BENEFITS:
        return <Benefits data={module} key={`page-component--${i}`} />

      case ModuleNames.BIO:
        return <Bio data={module} key={`page-component--${i}`} />

      case ModuleNames.COLLAPSIBLE_QUADRANT:
        return <CollapsibleQuadrant data={module} key={`page-component--${i}`} />

      case ModuleNames.GLOBAL_CONTENT_COLUMNS:
        return <ContentColumns data={module} key={`page-component--${i}`} />

      case ModuleNames.GLOBAL_CONTENT_BLOCK:
        return <ContentBlock data={module} key={`page-component--${i}`} />

      case ModuleNames.CONTENT_ROWS:
        return <ContentRows data={module} key={`page-component--${i}`} />

      case ModuleNames.DIVIDER:
        return <Divider data={module} key={`page-component--${i}`} />

      case ModuleNames.FLEXIBLE_HERO:
        return <FlexibleHero data={module} key={`page-component--${i}`} />

      case ModuleNames.GRID:
        return <Grid data={module} key={`page-component--${i}`} />

      case ModuleNames.HERO:
        return <Hero data={module} key={`page-component--${i}`} />

      case ModuleNames.GLOBAL_KEY_STATS:
        return <KeyStats data={module} key={`page-component--${i}`} />

      case ModuleNames.GLOBAL_MAIN_CTA:
        return <MainCTA data={module} key={`page-component--${i}`} />

      case ModuleNames.MEDIA_ASSET:
        return <MediaText data={module} key={`page-component--${i}`} />

      case ModuleNames.PARAGRAPH_BLOCK:
        return <ParagraphBlock data={module} key={`page-component--${i}`} />

      case ModuleNames.PLATFORM_DIAGRAM:
        return <PlatformDiagram data={module} key={`page-component--${i}`} />

      case ModuleNames.PRODUCT_DOWNLOAD_COMPONENT:
        return <ProductDownload data={module} key={`page-component--${i}`} />

      case ModuleNames.QUOTE:
        return <Quote data={module} key={`page-component--${i}`} />

      case ModuleNames.RAW_HTML:
        return <RawHTML data={module} key={`page-component--${i}`} />

      case ModuleNames.RESOURCE_LISTS:
        return <ResourceLists data={module} key={`page-component--${i}`} />

      case ModuleNames.RESOURCE_ROW:
        return (
          <ResourceRow
            data={module}
            key={`page-component--${i}`}
            locale={LocaleCodes.ENGLISH.code}
          />
        )

      case ModuleNames.RESOURCE_TABS:
        return <ResourceTabs data={module} key={`page-component--${i}`} />

      case ModuleNames.SLIDER:
        return <SliderComponent data={module} key={`page-component--${i}`} />

      case ModuleNames.SPEAKER_TEXT:
        return <SpeakerText data={module} key={`page-component--${i}`} />

      case ModuleNames.TABLE:
        return <Tables data={module} key={`page-component--${i}`} />

      case ModuleNames.TILES:
        return <Tiles data={module} key={`page-component--${i}`} />

      case ModuleNames.VIDEO_SPOTLIGHT:
        return <VideoSpotlight data={module} key={`page-component--${i}`} />

      default:
        return null
    }
  })

  return (
    <Layout.Template lang={defaultLocale} slug={slug} hideNormalLayout={true}>
      {dynamicPageContent}
    </Layout.Template>
  )
}

export default agencyTestPage
